import Accordion from '@components/Accordion';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    name: string;
    children?: ReactNode;
}

function PermissionItem({ name, children }:Props) {
    const { t } = useTranslation('permission');
    return (
        <Accordion title={
            <Leading>
                <TypeWrapper>
                    <Text color={colors.white}>
                        {t('optional')}
                    </Text>
                </TypeWrapper>
                <Text color={colors.gray6} fontWeight='bold' size='title'>
                    {name}
                </Text>
            </Leading>} >
            {children}
        </Accordion>
    );
}

const Leading = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
    flex: 1;
`;

const TypeWrapper = styled.div`
    background-color: ${colors.gray4};
    border-radius: var(--radius-sm);
    padding: 0 var(--spacing-2);
`;

export default PermissionItem;
